/* CLAYCALI 30/10/26: Lumina Name Set page. Gallery, one name on three pieces, finish, ring size, three cart lines -> checkout.
   2/11/26: letters per piece (data-max1..3). If the shared name is longer than the ring allows, a ring name field opens. */
(function () {
  var root = document.getElementById('lset'); if (!root || root.__ls) return; root.__ls = 1;
  var H = [root.dataset.h1, root.dataset.h2, root.dataset.h3];
  var KEYS = [root.dataset.key1 || 'ENTER NAME', root.dataset.key2 || 'ENTER NAME', root.dataset.key3 || 'ENTER NAME'];
  var MX = [+root.dataset.max1 || 12, +root.dataset.max2 || 12, +root.dataset.max3 || 10];
  var P = [], color = 'Gold', size = '', diff = false;
  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function toast(t) { var el = $('[data-ls-toast]'); el.textContent = t; el.classList.add('show'); clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('show'); }, 2400); }
  function optIx(p, re) { for (var i = 0; i < p.options.length; i++) if (re.test(p.options[i].name || p.options[i])) return i; return -1; }

  /* gallery: swipe track + thumbs + arrows */
  var track = $('[data-ls-track]'), thumbs = $$('[data-ls-thumbs] button');
  function cur() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
  function go(i) { if (!track) return; var n = track.children.length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
  function mark() { var i = cur(); thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); }); }
  thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
  $$('[data-ls-go]').forEach(function (b) { b.addEventListener('click', function () { go(cur() + (+b.dataset.lsGo)); }); });
  if (track) { var st; track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { mark(); var on = thumbs[cur()]; if (on) on.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }, 80); }, { passive: true }); mark(); }

  /* delivery window: today + 14 to 19 days */
  function md(x) { return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  var t = new Date(), a = new Date(t), b = new Date(t); a.setDate(t.getDate() + 14); b.setDate(t.getDate() + 19);
  var eta = $('[data-ls-eta]'); if (eta) eta.textContent = md(a) + ' and ' + md(b);
  $$('[data-ls-num]').forEach(function (e) { var n = +e.textContent; if (n) e.textContent = n.toLocaleString('en-US'); });

  /* load the three products */
  Promise.all(H.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }); })).then(function (list) {
    P = list; drawSizes(); paint();
  }).catch(function () {});

  function drawSizes() {
    var ring = P[2], box = $('[data-ls-size]'); if (!ring || !box) return;
    var si = optIx(ring, /size/i); if (si < 0) { box.closest('.ls-step').hidden = true; return; }
    box.innerHTML = ring.options[si].values.map(function (v) { return '<button type="button" data-v="' + String(v).replace(/"/g, '&quot;') + '">' + v + '</button>'; }).join('');
    $$('button', box).forEach(function (btn) { btn.onclick = function () { size = btn.dataset.v; $$('button', box).forEach(function (x) { x.classList.toggle('on', x === btn); }); $('[data-ls-size-err]').classList.remove('show'); }; });
  }
  function variantFor(p, i) {
    var ci = optIx(p, /colou?r|metal|finish|tone/i), si = optIx(p, /size/i);
    return p.variants.find(function (v) {
      return (ci < 0 || String(v.options[ci]).toLowerCase() === color.toLowerCase()) && (si < 0 || i !== 2 || v.options[si] === size);
    }) || null;
  }
  function imgFor(p) {
    var ci = optIx(p, /colou?r|metal|finish|tone/i); if (ci < 0) return '';
    var v = p.variants.find(function (x) { return String(x.options[ci]).toLowerCase() === color.toLowerCase() && x.featured_image; });
    var src = v && v.featured_image && v.featured_image.src; if (!src) return '';
    src = String(src); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=700';
  }
  function paint() {
    P.forEach(function (p, i) { var im = $('[data-ls-card="' + (i + 1) + '"] img'); var s = imgFor(p); if (im && s) { im.removeAttribute('srcset'); im.src = s; } });
    root.classList.toggle('is-silver', color === 'Silver');
    var ring = P[2], note = $('[data-ls-colornote]');
    if (note && ring) note.hidden = !(color === 'Silver' && optIx(ring, /colou?r|metal|finish|tone/i) < 0);
  }

  /* finish */
  $$('[data-ls-color] button').forEach(function (btn) { btn.onclick = function () { color = btn.dataset.v; $$('[data-ls-color] button').forEach(function (x) { x.classList.toggle('on', x === btn); }); paint(); }; });

  /* names */
  var allEl = $('[data-ls-name="all"]'), ringBox = $('[data-ls-f="ringshort"]'), ringEl = $('[data-ls-name="ringshort"]');
  function clean(v) { v = v.replace(/[^A-Za-zÀ-ÿ '-]/g, ''); return v ? v.charAt(0).toUpperCase() + v.slice(1) : v; }
  function ringNeedsOwn() { return !diff && allEl.value.trim().length > MX[2]; }
  function nameOf(i) {
    if (diff) { var el = $('[data-ls-name="' + (i + 1) + '"]'); return (el && el.value || '').trim(); }
    if (i === 2 && ringNeedsOwn()) return (ringEl && ringEl.value || '').trim();
    return (allEl.value || '').trim();
  }
  function syncRing() { if (ringBox) ringBox.hidden = !ringNeedsOwn(); }
  function preview() { syncRing(); for (var i = 0; i < 3; i++) { var n = nameOf(i); $('[data-ls-pname="' + (i + 1) + '"]').textContent = n || 'Your Name'; } }
  $$('[data-ls-name]').forEach(function (el) {
    el.addEventListener('input', function () { var c = clean(el.value); if (c !== el.value) el.value = c; el.closest('.ls-fld').classList.remove('bad'); preview(); });
  });
  $('[data-ls-diff]').addEventListener('change', function (e) {
    diff = e.target.checked; $('[data-ls-diffbox]').hidden = !diff; $('[data-ls-f="all"]').hidden = diff;
    if (diff) {
      var v = allEl.value;
      $$('[data-ls-diffbox] input').forEach(function (x, k) { if (!x.value) x.value = (k === 2 && ringNeedsOwnFor(v) && ringEl.value) ? ringEl.value : v.slice(0, MX[k]); });
    }
    preview();
  });
  function ringNeedsOwnFor(v) { return v.trim().length > MX[2]; }

  /* add to cart: three normal lines; the site's Buy 2 Get 1 makes the lowest-priced one free */
  function add() {
    var ok = true, first = null;
    if (!P.length) { toast('Still loading, one moment.'); return; }
    var need = diff ? ['1', '2', '3'] : (ringNeedsOwn() ? ['all', 'ringshort'] : ['all']);
    need.forEach(function (k) { var el = $('[data-ls-name="' + k + '"]'); if (!el.value.trim()) { ok = false; el.closest('.ls-fld').classList.add('bad'); first = first || el; } });
    var ring = P[2]; if (ring && optIx(ring, /size/i) > -1 && !size) { ok = false; $('[data-ls-size-err]').classList.add('show'); first = first || $('[data-ls-size]'); }
    if (!ok) { first.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
    var items = [];
    for (var i = 0; i < 3; i++) {
      var v = variantFor(P[i], i);
      if (!v || !v.available) { toast(P[i].title + ' is not available in ' + color + (i === 2 ? ' / size ' + size : '') + '.'); return; }
      var props = {}; props[KEYS[i]] = nameOf(i).slice(0, MX[i]); props._set = 'lumina-set';
      items.push({ id: v.id, quantity: 1, properties: props });
    }
    var btns = $$('[data-ls-add],[data-ls-barbtn]'); btns.forEach(function (x) { x.disabled = true; }); var main = $('[data-ls-add]'), lbl = main.textContent; main.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () { location.href = '/checkout'; })
      .catch(function () { btns.forEach(function (x) { x.disabled = false; }); main.textContent = lbl; var n = $('[data-ls-note]'); n.hidden = false; n.textContent = 'Something went wrong. Please try again.'; });
  }
  $('[data-ls-add]').addEventListener('click', add);

  /* scroll links + sticky bar */
  function toBuild() { var el = $('#ls-build'); window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 10, behavior: 'smooth' }); }
  $$('[data-ls-scroll]').forEach(function (x) { x.addEventListener('click', function (e) { e.preventDefault(); toBuild(); }); });
  $('[data-ls-barbtn]').addEventListener('click', toBuild);
  var bar = $('[data-ls-bar]'), heroBtn = $('.ls-hero .ls-btn'), build = $('#ls-build');
  function barCheck() {
    var vh = window.innerHeight, r = build.getBoundingClientRect();
    bar.classList.toggle('show', heroBtn.getBoundingClientRect().bottom < 0 && !(r.top < vh * 0.8 && r.bottom > vh * 0.2));
  }
  window.addEventListener('scroll', barCheck, { passive: true }); window.addEventListener('resize', barCheck); barCheck();
})();
